@if (hasErrorMessage) {
  <div class="app-error">
    {{ errorMessage }}
  </div>
}
